import { render, staticRenderFns } from "./TrafficMessageAffectedTrainsText.vue?vue&type=template&id=bd0d4e46"
import script from "./TrafficMessageAffectedTrainsText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageAffectedTrainsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports